<script>

    import MixinList from '@/Libs/Mixins/ListTab.js';

    export default {
        mixins: [MixinList],
        props: {
            branch: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                routeName: 'branch-detail',
                tabName: 'reservation'
            }
        },
        methods: {
            async _search(search) {
                return await this.$api.Reservation.all(search);
            },
            doSearch() {
                if (this.search.order_by)
                    this.search.order_by = this.$orderBy.toString();

                this.$router.replace({ name: 'branch-detail', params: { id: this.$route.params.id }, query: this.search });
            },
            _beforeSearch(search) {
                var vm = this;

                var date = new Date();
                var range = vm.$dateFormat.iso(date);

                search.branch_id = vm.$route.params.id;
                search.status = 'pending,approved,going';
                search.order_by = 'booked';
                search.sort_by = 'desc';
                search.date_from = range;
                search.date_to = range;

                delete search.tabIndex;

                return search;
            },
            async setStatus(params) {
                var vm = this;
                this.$loading.on('branch_detail_reservation_status_submit_' + params.id);

                try {
                    var resp = await this.$api.Reservation.status(params);
                    var data = resp.data;

                    vm._doSearch();

                    this.$flash.success(data.message);
                } catch (err) {
                    this.$flash.error(err.response.data.message);
                }
                this.$loading.off('branch_detail_reservation_status_submit_' + params.id);
            },
            accept(id) {
                this.setStatus({ id: id, status: 'approved' });
            },
            reject(id) {
                this.setStatus({ id: id, status: 'reject' });
            },
            cancel(id) {
                this.setStatus({ id: id, status: 'cancel' });
            },
            signin(id) {
                this.setStatus({ id: id, status: 'going' });
            },
            signout(id) {
                this.setStatus({ id: id, status: 'done' });
            }
        }
    };
</script>

<template>
    <BRow class="g-4 align-items-center mb-3">
        <BCol sm="auto">
            <div class="d-flex flex-wrap align-items-start gap-2">
                <BButton type="button" variant="success"
                    @click="$router.push({ name: 'reservation-create', query: { store_id: branch.store_id, branch_id: branch.id } })"
                    v-if="$ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(branch.id) || $ac.hasAccessStore(branch.store_id)))">
                    <i class="mdi mdi-plus-thick align-bottom me-1"></i> {{ $t('basic.btn.add') }}
                </BButton>
                <BButton type="button" variant="info"
                    @click="$router.push({ name: 'reservation', query: { store_id: branch.store_id, branch_id: branch.id } })"
                    v-if="$ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_list') && ($ac.hasAccessBranch(branch.id) || $ac.hasAccessStore(branch.store_id)))">
                    <i class="mdi mdi-format-list-text align-bottom me-1"></i> {{ $t('basic.btn.more') }}
                </BButton>
                <BButton type="button" variant="warning"
                    @click="$router.push({ name: 'stuff-available', query: { store_id: branch.store_id, branch_id: branch.id, date: $dateFormat.nowDate(), } })"
                    v-if="$ac.hasAccess('stuff_available_full_access') || ($ac.hasAccess('stuff_available_list') && ($ac.hasAccessStore(branch.store_id) || $ac.hasAccessBranch(branch.id)))">
                    <i class="mdi mdi-format-list-text align-bottom me-1"></i> {{ $t('branch.btn.stuff_available') }}
                </BButton>
            </div>
        </BCol>
        <BCol sm>
            <div class="d-flex justify-content-sm-end">
                <div class="search-box ms-2">
                    <b-form @submit="doSearch()">
                        <input type="text" class="form-control" v-model="search.keyword"
                            :placeholder="$t('filter.placeholder.keyword')" />
                        <i class="mdi mdi-magnify search-icon"></i>
                    </b-form>
                </div>
            </div>
        </BCol>
    </BRow>
    <BRow>
        <BCol>
            <BAlert dismissible :model-value="true" variant="info" class="alert-border-left shadow">
                <i class="mdi mdi-information-outline align-middle fs-16"></i>
                {{ $t('branch.alert.reservation') }}
            </BAlert>
        </BCol>
    </BRow>
    <loading :loading="$loading.get([routeName, tabName, 'list'].join('_'))" variant="dark" type="block">
        <BRow>
            <BCol xxl="12">
                <div id="job-list">
                    <BCard no-body class="joblist-card ribbon-box border right cursor-pointer"
                        v-for="(tr, index) in list" :key="index" @click="
                            ($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_show') && ($ac.hasAccessBranch(branch.id) || $ac.hasAccessStore(branch.store_id)))) &&
                            ($router.push({ name: 'reservation-detail', params: { id: tr.id } }))" :class="[
                                search.is_deleted == 0 || search.is_deleted == null && ($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_show') && ($ac.hasAccessBranch(branch.id) || $ac.hasAccessStore(branch.store_id)))) ? 'cursor-pointer' : ''
                            ]">
                        <div class="table-responsive">
                            <BCardBody class="pb-2"
                                :class="{ 'bg-warning-subtle': tr.status_name == 'pending', 'bg-info-subtle': tr.status_name == 'going', 'bg-success-subtle': tr.status_name == 'approved' }">
                                <div class="table-responsive">
                                    <div class="ribbon ribbon-warning round-shape" v-if="tr.status_name == 'pending'">{{
                                        tr.status }}</div>
                                    <div class="ribbon ribbon-info round-shape" v-if="tr.status_name == 'going'">
                                        {{ tr.status
                                        }}
                                    </div>
                                    <div class="ribbon ribbon-success round-shape" v-if="tr.status_name == 'approved'">
                                        {{
                                            tr.status }}
                                    </div>
                                    <div class="d-flex mb-0 align-items-center">
                                        <div class="flex-shrink-0 avatar-sm">
                                            <div class="avatar-title rounded text-light" :class="{
                                                'bg-warning': tr.status_name == 'pending',
                                                'bg-success': tr.status_name == 'approved',
                                                'bg-info': tr.status_name == 'going',
                                            }">
                                                <i class="mdi mdi-handshake-outline fs-4"
                                                    v-if="tr.status_name == 'pending'"></i>
                                                <i class="mdi mdi-check-bold fs-4"
                                                    v-if="tr.status_name == 'approved'"></i>
                                                <i class="mdi mdi-login fs-4" v-if="tr.status_name == 'going'"></i>
                                            </div>
                                        </div>
                                        <div class="ms-3 flex-grow-1">
                                            <h6 class="job-title">{{ tr.user_name }}</h6>
                                            <span class="company-name text-muted">{{ tr.ref_no }}</span>
                                        </div>
                                    </div>
                                </div>
                            </BCardBody>
                            <BCardFooter class="border-top-dashed mt-0 pt-2 pb-2" :class="{
                                'bg-warning-subtle': tr.status_name == 'pending',
                                'bg-info-subtle': tr.status_name == 'going',
                                'bg-success-subtle': tr.status_name == 'approved',
                            }">
                                <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
                                    <div class="d-flex align-items-center">
                                        <i class="mdi mdi-view-quilt-outline align-bottom me-2 fs-4"></i> <span>{{
                                            tr.room
                                        }}</span>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <i class="mdi mdi-sofa-outline me-2 fs-4"></i> <span>{{ tr.stuff
                                        }}</span>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <i class="mdi mdi-calendar align-bottom me-2 fs-4"></i> <span>{{ tr.booked_at
                                        }}</span>
                                    </div>
                                    <div @click.stop class="d-flex align-items-center flex-wrap" v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(tr.branch_id) || $ac.hasAccessStore(tr.store_id)))) &&
                                        (['draft', 'pending', 'approved', 'going'].includes(tr.status_name))">
                                        <BDropdown variant="primary" size="md" class="me-1" strategy="fixed"
                                            :toggle-class="{
                                                'no-caret': $loading.get('branch_detail_reservation_status_submit_' + tr.id)
                                            }"
                                            :disabled="$loading.get('branch_detail_reservation_status_submit_' + tr.id)"
                                            v-if="search.is_deleted == 0 || search.is_deleted == null">
                                            <template #button-content
                                                class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                                                <loading
                                                    :loading="$loading.get('branch_detail_reservation_status_submit_' + tr.id)"
                                                    variant="light" type="button">
                                                    {{ $t('basic.btn.action') }}
                                                </loading>
                                            </template>
                                            <BDropdownItem @click.prevent="accept(tr.id)" variant="success"
                                                v-if="['draft'].includes(tr.status_name)">
                                                <i class="mdi mdi-check-bold fs-16"></i>
                                                {{ $t('reservation.btn.confirm') }}
                                            </BDropdownItem>
                                            <BDropdownItem @click.prevent="accept(tr.id)" variant="success"
                                                v-if="['pending'].includes(tr.status_name)">
                                                <i class="mdi mdi-check-bold fs-16"></i>
                                                {{ $t('reservation.btn.accept') }}
                                            </BDropdownItem>
                                            <BDropdownItem @click.prevent="reject(tr.id)" variant="danger"
                                                v-if="['pending'].includes(tr.status_name)">
                                                <i class="mdi mdi-close-thick fs-16"></i>
                                                {{ $t('reservation.btn.reject') }}
                                            </BDropdownItem>
                                            <BDropdownItem @click.prevent="signin(tr.id)" variant="info"
                                                v-if="['approved'].includes(tr.status_name)">
                                                <i class="mdi mdi-login fs-16"></i>
                                                {{ $t('reservation.btn.signin') }}
                                            </BDropdownItem>
                                            <BDropdownItem @click.prevent="cancel(tr.id)" variant="info"
                                                v-if="['approved'].includes(tr.status_name)">
                                                <i class="mdi mdi-login fs-16"></i>
                                                {{ $t('reservation.btn.cancel') }}
                                            </BDropdownItem>
                                            <BDropdownItem @click.prevent="signout(tr.id)" variant="dark"
                                                v-if="['going'].includes(tr.status_name)">
                                                <i class="mdi mdi-logout fs-16"></i>
                                                {{ $t('reservation.btn.signout') }}
                                            </BDropdownItem>
                                        </BDropdown>
                                    </div>
                                </div>
                            </BCardFooter>
                        </div>
                    </BCard>
                </div>
            </BCol>
        </BRow>
        <BRow class="g-0 justify-content-end mb-4" id="pagination-element">
            <BCol sm="6">
                <pagination v-bind:model="paginator" v-on:goto="goto"
                    :disabled="$loading.get([routeName, 'list'].join('_'))" />
            </BCol>
        </BRow>
    </loading>
</template>